export const BestInDental = {
  DISMISS_WINNER_POPUP: 'BEST_IN_DENTAL_DISMISS_WINNER_POPUP',
};
